export default {
  data() {
    return {
      scroll: 0,
      scroll_distance: 560,
    };
  },

  methods: {
    isArrowDisabled(value) {
      return this.scroll === value;
    },

    scrollPage(direction) {
      const distance = direction === "right" ? this.scroll_distance : -1 * this.scroll_distance;

      this.$refs.scroll.scrollBy({ dx: distance });
    },

    handleScroll() {
      this.scroll = this.$refs.scroll.getScrollProcess()["h"];
    },
  },
};
